// extracted by mini-css-extract-plugin
export default {"chromeframe":"logo_chromeframe__NK9SF","main":"logo_main__DX9be"};